import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerCard } from '@chess/api-dashboard';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import { RatingCard } from './RatingCard.tsx';
import { RatingSeriesAggregator } from './RatingSeriesAggregator.ts';

// Home dashboard card "Rating trend": registers its own aggregator with the
// game store and reads its result and renders `RatingCard`, its body, in the Summary section's frame
// (`home.section.summary`, order 10, `registerCard`).
// A click on a slice opens the library filtered to it and to the card's last
// 30 days (`libraryLink`), so the library lists the games the card counted.
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new RatingSeriesAggregator();
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    const p = state?.period;
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <RatingCard loading />;
    return result && p ? <RatingCard rating={result} from={p.from} to={p.to} link={link} /> : null;
  };
  registerCard(app, 'home.section.summary', Card, { order: 10, title: 'Rating trend' });
}
